export const NAME = "earnings" as const;
